import { HttpClient } from '@angular/common/http';
import BigNumber from 'bignumber.js';
import { tap } from 'rxjs/operators';
import { Base } from '../base';

export class PositionUpdates extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/position_updates`);
  }

  query(params?: any) {
    return this.api.query(params).pipe(
      tap((json) => json.positionUpdates.forEach((record: any) => this.processRecord(record)))
    );
  }

  private processRecord(record: any) {
    record.strike = new BigNumber(record.strike).fromDecimal();
    record.premium = new BigNumber(record.premium).fromDecimal();
    record.size = new BigNumber(record.size).fromDecimal();
    record.realized = new BigNumber(record.realized).fromDecimal();
    record.fee = new BigNumber(record.fee).fromDecimal();
    record.gasFee = new BigNumber(record.gasFee).fromDecimal();
    record.avg = record.premium.div(record.size).abs();
  }
}
